export const SuppliersRoutes = {
  path: 'suppliers',
  async lazy() {
    const { Parent } = await import('pages/supplier-management');
    return { Component: Parent };
  },
  handle: { name: 'Supplier management', category: 'Supplier management' },
  children: [
    {
      index: true,
      async lazy() {
        const { Index } = await import('pages/supplier-management');
        return { Component: Index };
      },
    },
    {
      path: ':supplierId',
      async lazy() {
        const { Details } = await import('pages/supplier-management');
        return { Component: Details };
      },
      handle: { name: 'Supplier Detail Page', category: 'Supplier management' },
      children: [
        {
          index: true,
          async lazy() {
            const { BasicInfo } = await import('pages/supplier-management');
            return { Component: BasicInfo };
          },
        },
        {
          path: 'edit',
          async lazy() {
            const { EditSupplier } = await import('pages/supplier-management');
            return { Component: EditSupplier };
          },
          handle: { name: 'Edit supplier', category: 'Supplier management' },
        },
        {
          path: 'facilities',
          async lazy() {
            const { Facilities } = await import('pages/supplier-management');
            return { Component: Facilities };
          },
          handle: { name: 'Facilities', category: 'Supplier management' },
          children: [
            {
              path: 'add',
              async lazy() {
                const { SupplierFacilitiesModal } = await import('pages/supplier-management');
                return { Component: SupplierFacilitiesModal };
              },
            },
            {
              path: ':facilityId/edit',
              async lazy() {
                const { SupplierFacilitiesEditModal } = await import('pages/supplier-management');
                return { Component: SupplierFacilitiesEditModal };
              },
            },
          ],
        },
      ],
    },
    {
      path: 'add',
      async lazy() {
        const { AddSupplier } = await import('pages/supplier-management');
        return { Component: AddSupplier };
      },
      handle: { name: 'Add new supplier', category: 'Supplier management' },
    },
  ],
};
